import { Component, useState } from "react";
import { LabelContainer } from "../assets/style";
import { Box, FormControl, IconButton, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import FormLongLabel from "./FormLongLabel";
import { deleteIcon } from "../assets/imgs";
import { useTranslation } from "react-i18next";
export default function RemovableFormDropDownList(props: { title?: any, sameRowTitle?: any, value?: any, removeButton?: boolean, onCancel?: () => void, handleValueChange: Function, items: Array<string> }) {
    const { title, sameRowTitle, value, removeButton, onCancel, handleValueChange, items } = props
    const {t, i18n} = useTranslation();

    return (
        <Box sx={{ m: '10px' }}>
            {title && <FormLongLabel title={t(title)} />}
            <Box sx={{ minWidth: 120, display: "flex" }}>
                {
                    sameRowTitle && <LabelContainer style={{ marginLeft: "28px" }}>
                        {sameRowTitle + ": "}
                    </LabelContainer>
                }
                <FormControl sx={{
                    marginLeft: "20px",
                    width: "50%"
                }}>
                    <Select
                        value={value}
                        onChange={(event) => handleValueChange(event)}
                        style={{ marginBottom: "20px", backgroundColor: "white", height: "32px" }}
                    >
                        {items.map((item, index) => (
                            <MenuItem key={index} value={item}>
                                {item}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {removeButton && <IconButton style={{ marginBottom: "20px", height: "32px" }} onClick={onCancel}>
                    <img src={deleteIcon} />
                </IconButton>}
            </Box>
        </Box>
    );
}
